import React from "react";
export default function DominanceBar({ data }) {
  if (!data?.btc) return null;
  return (
    <div style={{ display:"flex",alignItems:"center",gap:20,padding:"6px 20px",
      background:"#0a0c10",borderBottom:"1px solid #1a1f2e",fontSize:12 }}>
      <span style={{ color:"#6b7280" }}>도미넌스</span>
      <span><span style={{ color:"#f59e0b",fontWeight:700 }}>BTC</span> {data.btc}%</span>
      <span><span style={{ color:"#6366f1",fontWeight:700 }}>ETH</span> {data.eth}%</span>
      <span style={{ color:"#374151" }}>Others {data.others}%</span>
      <div style={{ flex:1,height:6,background:"#1e2433",borderRadius:3,overflow:"hidden",display:"flex" }}>
        <div style={{ width:`${data.btc}%`,background:"#f59e0b" }}/>
        <div style={{ width:`${data.eth}%`,background:"#6366f1" }}/>
        <div style={{ flex:1,background:"#374151" }}/>
      </div>
    </div>
  );
}
